/**
 * Generated by orval v6.27.1 🍺
 * Do not edit manually.
 * Workspace Warden
 * OpenAPI spec version: 0.0.1
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import type {
  AddAuthorizedUserDto,
  AddMemberDto,
  AuthControllerLoginParams,
  ChecklistControllerFindAllParams,
  ChecklistControllerUploadCsvBody,
  ChecklistDto,
  ChecklistMembersDto,
  ChecklistProductsDto,
  ChecklistSearchResultDto,
  ConnectChecklistProductsDto,
  CreateChecklistDto,
  CreateSubscriptionTransactionDto,
  DeleteChecklistMembersDto,
  DeleteChecklistProductsDto,
  GetAuthorizedUsersDto,
  GetBillingInfoDto,
  GetPaymentStatusDto,
  GlobalSearchResultDto,
  ImpersonatorDto,
  LoginInfoDto,
  OrgUnitsDto,
  ProductDetailsDto,
  ProductSearchResultDto,
  RemoveAuthorizedUserDto,
  RemoveMemberDto,
  SearchControllerGetAllProductsParams,
  SearchControllerSearchAllParams,
  SearchControllerSearchChecklistsParams,
  SearchControllerSearchProductsParams,
  SearchControllerSearchUsersParams,
  SetBillingInfoDto,
  SubscriptionInfoDto,
  SyncInfoDto,
  TenantSubscriptionStatusDto,
  UpdateChecklistDto,
  UpdateChecklistMembersDto,
  UpdateMemberRoleDto,
  UserSearchResultDto,
} from '../models';
import { customInstance } from '../../src/api/axios-instance';

export const checklistControllerCreate = (
  createChecklistDto: CreateChecklistDto,
) => {
  return customInstance<ChecklistDto>({
    url: `/api/checklist`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createChecklistDto,
  });
};

export const getChecklistControllerCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerCreate>>,
    TError,
    { data: CreateChecklistDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checklistControllerCreate>>,
  TError,
  { data: CreateChecklistDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checklistControllerCreate>>,
    { data: CreateChecklistDto }
  > = (props) => {
    const { data } = props ?? {};

    return checklistControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChecklistControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerCreate>>
>;
export type ChecklistControllerCreateMutationBody = CreateChecklistDto;
export type ChecklistControllerCreateMutationError = unknown;

export const useChecklistControllerCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerCreate>>,
    TError,
    { data: CreateChecklistDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checklistControllerCreate>>,
  TError,
  { data: CreateChecklistDto },
  TContext
> => {
  const mutationOptions = getChecklistControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checklistControllerFindAll = (
  params?: ChecklistControllerFindAllParams,
  signal?: AbortSignal,
) => {
  return customInstance<ChecklistDto[]>({
    url: `/api/checklist`,
    method: 'GET',
    params,
    signal,
  });
};

export const getChecklistControllerFindAllQueryKey = (
  params?: ChecklistControllerFindAllParams,
) => {
  return [`/api/checklist`, ...(params ? [params] : [])] as const;
};

export const getChecklistControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof checklistControllerFindAll>>,
  TError = void,
>(
  params?: ChecklistControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChecklistControllerFindAllQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checklistControllerFindAll>>
  > = ({ signal }) => checklistControllerFindAll(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checklistControllerFindAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChecklistControllerFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerFindAll>>
>;
export type ChecklistControllerFindAllQueryError = void;

export const useChecklistControllerFindAll = <
  TData = Awaited<ReturnType<typeof checklistControllerFindAll>>,
  TError = void,
>(
  params?: ChecklistControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistControllerFindAll>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getChecklistControllerFindAllQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const checklistControllerGetChecklist = (
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<ChecklistDto>({
    url: `/api/checklist/${id}`,
    method: 'GET',
    signal,
  });
};

export const getChecklistControllerGetChecklistQueryKey = (id: string) => {
  return [`/api/checklist/${id}`] as const;
};

export const getChecklistControllerGetChecklistQueryOptions = <
  TData = Awaited<ReturnType<typeof checklistControllerGetChecklist>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistControllerGetChecklist>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChecklistControllerGetChecklistQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checklistControllerGetChecklist>>
  > = ({ signal }) => checklistControllerGetChecklist(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checklistControllerGetChecklist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChecklistControllerGetChecklistQueryResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerGetChecklist>>
>;
export type ChecklistControllerGetChecklistQueryError = unknown;

export const useChecklistControllerGetChecklist = <
  TData = Awaited<ReturnType<typeof checklistControllerGetChecklist>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistControllerGetChecklist>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getChecklistControllerGetChecklistQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const checklistControllerRename = (
  id: string,
  updateChecklistDto: UpdateChecklistDto,
) => {
  return customInstance<void>({
    url: `/api/checklist/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateChecklistDto,
  });
};

export const getChecklistControllerRenameMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerRename>>,
    TError,
    { id: string; data: UpdateChecklistDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checklistControllerRename>>,
  TError,
  { id: string; data: UpdateChecklistDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checklistControllerRename>>,
    { id: string; data: UpdateChecklistDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return checklistControllerRename(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChecklistControllerRenameMutationResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerRename>>
>;
export type ChecklistControllerRenameMutationBody = UpdateChecklistDto;
export type ChecklistControllerRenameMutationError = unknown;

export const useChecklistControllerRename = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerRename>>,
    TError,
    { id: string; data: UpdateChecklistDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checklistControllerRename>>,
  TError,
  { id: string; data: UpdateChecklistDto },
  TContext
> => {
  const mutationOptions = getChecklistControllerRenameMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checklistControllerRemove = (id: string) => {
  return customInstance<void>({
    url: `/api/checklist/${id}`,
    method: 'DELETE',
  });
};

export const getChecklistControllerRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checklistControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checklistControllerRemove>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return checklistControllerRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChecklistControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerRemove>>
>;

export type ChecklistControllerRemoveMutationError = unknown;

export const useChecklistControllerRemove = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checklistControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getChecklistControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checklistControllerConnectProduct = (
  id: string,
  connectChecklistProductsDto: ConnectChecklistProductsDto,
) => {
  return customInstance<ChecklistProductsDto>({
    url: `/api/checklist/${id}/products`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: connectChecklistProductsDto,
  });
};

export const getChecklistControllerConnectProductMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerConnectProduct>>,
    TError,
    { id: string; data: ConnectChecklistProductsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checklistControllerConnectProduct>>,
  TError,
  { id: string; data: ConnectChecklistProductsDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checklistControllerConnectProduct>>,
    { id: string; data: ConnectChecklistProductsDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return checklistControllerConnectProduct(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChecklistControllerConnectProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerConnectProduct>>
>;
export type ChecklistControllerConnectProductMutationBody =
  ConnectChecklistProductsDto;
export type ChecklistControllerConnectProductMutationError = unknown;

export const useChecklistControllerConnectProduct = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerConnectProduct>>,
    TError,
    { id: string; data: ConnectChecklistProductsDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checklistControllerConnectProduct>>,
  TError,
  { id: string; data: ConnectChecklistProductsDto },
  TContext
> => {
  const mutationOptions =
    getChecklistControllerConnectProductMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checklistControllerDeleteConnction = (
  id: string,
  deleteChecklistProductsDto: DeleteChecklistProductsDto,
) => {
  return customInstance<void>({
    url: `/api/checklist/${id}/products`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteChecklistProductsDto,
  });
};

export const getChecklistControllerDeleteConnctionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerDeleteConnction>>,
    TError,
    { id: string; data: DeleteChecklistProductsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checklistControllerDeleteConnction>>,
  TError,
  { id: string; data: DeleteChecklistProductsDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checklistControllerDeleteConnction>>,
    { id: string; data: DeleteChecklistProductsDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return checklistControllerDeleteConnction(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChecklistControllerDeleteConnctionMutationResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerDeleteConnction>>
>;
export type ChecklistControllerDeleteConnctionMutationBody =
  DeleteChecklistProductsDto;
export type ChecklistControllerDeleteConnctionMutationError = unknown;

export const useChecklistControllerDeleteConnction = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerDeleteConnction>>,
    TError,
    { id: string; data: DeleteChecklistProductsDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checklistControllerDeleteConnction>>,
  TError,
  { id: string; data: DeleteChecklistProductsDto },
  TContext
> => {
  const mutationOptions =
    getChecklistControllerDeleteConnctionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checklistControllerGetMembers = (
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<ChecklistMembersDto>({
    url: `/api/checklist/${id}/members`,
    method: 'GET',
    signal,
  });
};

export const getChecklistControllerGetMembersQueryKey = (id: string) => {
  return [`/api/checklist/${id}/members`] as const;
};

export const getChecklistControllerGetMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof checklistControllerGetMembers>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistControllerGetMembers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChecklistControllerGetMembersQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checklistControllerGetMembers>>
  > = ({ signal }) => checklistControllerGetMembers(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checklistControllerGetMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChecklistControllerGetMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerGetMembers>>
>;
export type ChecklistControllerGetMembersQueryError = unknown;

export const useChecklistControllerGetMembers = <
  TData = Awaited<ReturnType<typeof checklistControllerGetMembers>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistControllerGetMembers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getChecklistControllerGetMembersQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const checklistControllerAddMembers = (
  id: string,
  updateChecklistMembersDto: UpdateChecklistMembersDto,
) => {
  return customInstance<ChecklistMembersDto>({
    url: `/api/checklist/${id}/members`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateChecklistMembersDto,
  });
};

export const getChecklistControllerAddMembersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerAddMembers>>,
    TError,
    { id: string; data: UpdateChecklistMembersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checklistControllerAddMembers>>,
  TError,
  { id: string; data: UpdateChecklistMembersDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checklistControllerAddMembers>>,
    { id: string; data: UpdateChecklistMembersDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return checklistControllerAddMembers(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChecklistControllerAddMembersMutationResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerAddMembers>>
>;
export type ChecklistControllerAddMembersMutationBody =
  UpdateChecklistMembersDto;
export type ChecklistControllerAddMembersMutationError = unknown;

export const useChecklistControllerAddMembers = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerAddMembers>>,
    TError,
    { id: string; data: UpdateChecklistMembersDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checklistControllerAddMembers>>,
  TError,
  { id: string; data: UpdateChecklistMembersDto },
  TContext
> => {
  const mutationOptions =
    getChecklistControllerAddMembersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checklistControllerDeleteMembers = (
  id: string,
  deleteChecklistMembersDto: DeleteChecklistMembersDto,
) => {
  return customInstance<void>({
    url: `/api/checklist/${id}/members`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteChecklistMembersDto,
  });
};

export const getChecklistControllerDeleteMembersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerDeleteMembers>>,
    TError,
    { id: string; data: DeleteChecklistMembersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checklistControllerDeleteMembers>>,
  TError,
  { id: string; data: DeleteChecklistMembersDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checklistControllerDeleteMembers>>,
    { id: string; data: DeleteChecklistMembersDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return checklistControllerDeleteMembers(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChecklistControllerDeleteMembersMutationResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerDeleteMembers>>
>;
export type ChecklistControllerDeleteMembersMutationBody =
  DeleteChecklistMembersDto;
export type ChecklistControllerDeleteMembersMutationError = unknown;

export const useChecklistControllerDeleteMembers = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerDeleteMembers>>,
    TError,
    { id: string; data: DeleteChecklistMembersDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checklistControllerDeleteMembers>>,
  TError,
  { id: string; data: DeleteChecklistMembersDto },
  TContext
> => {
  const mutationOptions =
    getChecklistControllerDeleteMembersMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checklistControllerUploadCsv = (
  checklistControllerUploadCsvBody: ChecklistControllerUploadCsvBody,
) => {
  const formData = new FormData();
  formData.append('name', checklistControllerUploadCsvBody.name);
  formData.append('file', checklistControllerUploadCsvBody.file);

  return customInstance<ChecklistDto>({
    url: `/api/checklist/upload`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getChecklistControllerUploadCsvMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerUploadCsv>>,
    TError,
    { data: ChecklistControllerUploadCsvBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checklistControllerUploadCsv>>,
  TError,
  { data: ChecklistControllerUploadCsvBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checklistControllerUploadCsv>>,
    { data: ChecklistControllerUploadCsvBody }
  > = (props) => {
    const { data } = props ?? {};

    return checklistControllerUploadCsv(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChecklistControllerUploadCsvMutationResult = NonNullable<
  Awaited<ReturnType<typeof checklistControllerUploadCsv>>
>;
export type ChecklistControllerUploadCsvMutationBody =
  ChecklistControllerUploadCsvBody;
export type ChecklistControllerUploadCsvMutationError = unknown;

export const useChecklistControllerUploadCsv = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checklistControllerUploadCsv>>,
    TError,
    { data: ChecklistControllerUploadCsvBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checklistControllerUploadCsv>>,
  TError,
  { data: ChecklistControllerUploadCsvBody },
  TContext
> => {
  const mutationOptions =
    getChecklistControllerUploadCsvMutationOptions(options);

  return useMutation(mutationOptions);
};

export const subscriptionControllerCreateSubscription = (
  subscriptionInfoDto: SubscriptionInfoDto,
) => {
  return customInstance<CreateSubscriptionTransactionDto>({
    url: `/api/subscriptions/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: subscriptionInfoDto,
  });
};

export const getSubscriptionControllerCreateSubscriptionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscriptionControllerCreateSubscription>>,
    TError,
    { data: SubscriptionInfoDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscriptionControllerCreateSubscription>>,
  TError,
  { data: SubscriptionInfoDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscriptionControllerCreateSubscription>>,
    { data: SubscriptionInfoDto }
  > = (props) => {
    const { data } = props ?? {};

    return subscriptionControllerCreateSubscription(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscriptionControllerCreateSubscriptionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof subscriptionControllerCreateSubscription>>
  >;
export type SubscriptionControllerCreateSubscriptionMutationBody =
  SubscriptionInfoDto;
export type SubscriptionControllerCreateSubscriptionMutationError = unknown;

export const useSubscriptionControllerCreateSubscription = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscriptionControllerCreateSubscription>>,
    TError,
    { data: SubscriptionInfoDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof subscriptionControllerCreateSubscription>>,
  TError,
  { data: SubscriptionInfoDto },
  TContext
> => {
  const mutationOptions =
    getSubscriptionControllerCreateSubscriptionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const subscriptionControllerGetMyCustomer = (signal?: AbortSignal) => {
  return customInstance<TenantSubscriptionStatusDto>({
    url: `/api/subscriptions/status`,
    method: 'GET',
    signal,
  });
};

export const getSubscriptionControllerGetMyCustomerQueryKey = () => {
  return [`/api/subscriptions/status`] as const;
};

export const getSubscriptionControllerGetMyCustomerQueryOptions = <
  TData = Awaited<ReturnType<typeof subscriptionControllerGetMyCustomer>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof subscriptionControllerGetMyCustomer>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSubscriptionControllerGetMyCustomerQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof subscriptionControllerGetMyCustomer>>
  > = ({ signal }) => subscriptionControllerGetMyCustomer(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof subscriptionControllerGetMyCustomer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SubscriptionControllerGetMyCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof subscriptionControllerGetMyCustomer>>
>;
export type SubscriptionControllerGetMyCustomerQueryError = void;

export const useSubscriptionControllerGetMyCustomer = <
  TData = Awaited<ReturnType<typeof subscriptionControllerGetMyCustomer>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof subscriptionControllerGetMyCustomer>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getSubscriptionControllerGetMyCustomerQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const subscriptionControllerUpdateRenewal = () => {
  return customInstance<void>({
    url: `/api/subscriptions/renew`,
    method: 'PATCH',
  });
};

export const getSubscriptionControllerUpdateRenewalMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscriptionControllerUpdateRenewal>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscriptionControllerUpdateRenewal>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscriptionControllerUpdateRenewal>>,
    void
  > = () => {
    return subscriptionControllerUpdateRenewal();
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscriptionControllerUpdateRenewalMutationResult = NonNullable<
  Awaited<ReturnType<typeof subscriptionControllerUpdateRenewal>>
>;

export type SubscriptionControllerUpdateRenewalMutationError = void;

export const useSubscriptionControllerUpdateRenewal = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscriptionControllerUpdateRenewal>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof subscriptionControllerUpdateRenewal>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getSubscriptionControllerUpdateRenewalMutationOptions(options);

  return useMutation(mutationOptions);
};

export const paymentControllerGetPaymentStatus = (
  id: string,
  signal?: AbortSignal,
) => {
  return customInstance<GetPaymentStatusDto>({
    url: `/api/payments/order/${id}`,
    method: 'GET',
    signal,
  });
};

export const getPaymentControllerGetPaymentStatusQueryKey = (id: string) => {
  return [`/api/payments/order/${id}`] as const;
};

export const getPaymentControllerGetPaymentStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof paymentControllerGetPaymentStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof paymentControllerGetPaymentStatus>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPaymentControllerGetPaymentStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof paymentControllerGetPaymentStatus>>
  > = ({ signal }) => paymentControllerGetPaymentStatus(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof paymentControllerGetPaymentStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PaymentControllerGetPaymentStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof paymentControllerGetPaymentStatus>>
>;
export type PaymentControllerGetPaymentStatusQueryError = void;

export const usePaymentControllerGetPaymentStatus = <
  TData = Awaited<ReturnType<typeof paymentControllerGetPaymentStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof paymentControllerGetPaymentStatus>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getPaymentControllerGetPaymentStatusQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const paymentControllerHandlePaymentStatusNotification = () => {
  return customInstance<void>({
    url: `/api/payments/order/notify`,
    method: 'POST',
  });
};

export const getPaymentControllerHandlePaymentStatusNotificationMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof paymentControllerHandlePaymentStatusNotification>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof paymentControllerHandlePaymentStatusNotification>
    >,
    TError,
    void,
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof paymentControllerHandlePaymentStatusNotification>
      >,
      void
    > = () => {
      return paymentControllerHandlePaymentStatusNotification();
    };

    return { mutationFn, ...mutationOptions };
  };

export type PaymentControllerHandlePaymentStatusNotificationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof paymentControllerHandlePaymentStatusNotification>>
  >;

export type PaymentControllerHandlePaymentStatusNotificationMutationError =
  unknown;

export const usePaymentControllerHandlePaymentStatusNotification = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof paymentControllerHandlePaymentStatusNotification>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof paymentControllerHandlePaymentStatusNotification>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getPaymentControllerHandlePaymentStatusNotificationMutationOptions(options);

  return useMutation(mutationOptions);
};

export const searchControllerGetAllProducts = (
  params?: SearchControllerGetAllProductsParams,
) => {
  return customInstance<ProductSearchResultDto[]>({
    url: `/api/search/products`,
    method: 'GET',
    params,
  });
};

export const getSearchControllerGetAllProductsQueryKey = (
  params?: SearchControllerGetAllProductsParams,
) => {
  return [`/api/search/products`, ...(params ? [params] : [])] as const;
};

export const getSearchControllerGetAllProductsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
    SearchControllerGetAllProductsParams['page']
  >,
  TError = unknown,
>(
  params?: SearchControllerGetAllProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
        TError,
        TData,
        Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
        QueryKey,
        SearchControllerGetAllProductsParams['page']
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchControllerGetAllProductsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
    QueryKey,
    SearchControllerGetAllProductsParams['page']
  > = ({ pageParam }) =>
    searchControllerGetAllProducts({
      ...params,
      page: pageParam || params?.['page'],
    });

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
    TError,
    TData,
    Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
    QueryKey,
    SearchControllerGetAllProductsParams['page']
  > & { queryKey: QueryKey };
};

export type SearchControllerGetAllProductsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchControllerGetAllProducts>>
>;
export type SearchControllerGetAllProductsInfiniteQueryError = unknown;

export const useSearchControllerGetAllProductsInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
    SearchControllerGetAllProductsParams['page']
  >,
  TError = unknown,
>(
  params?: SearchControllerGetAllProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
        TError,
        TData,
        Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
        QueryKey,
        SearchControllerGetAllProductsParams['page']
      >
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchControllerGetAllProductsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getSearchControllerGetAllProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
  TError = unknown,
>(
  params?: SearchControllerGetAllProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchControllerGetAllProductsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchControllerGetAllProducts>>
  > = () => searchControllerGetAllProducts(params);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchControllerGetAllProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchControllerGetAllProducts>>
>;
export type SearchControllerGetAllProductsQueryError = unknown;

export const useSearchControllerGetAllProducts = <
  TData = Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
  TError = unknown,
>(
  params?: SearchControllerGetAllProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerGetAllProducts>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchControllerGetAllProductsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const searchControllerSearchProducts = (
  query: string,
  params?: SearchControllerSearchProductsParams,
  signal?: AbortSignal,
) => {
  return customInstance<ProductSearchResultDto[]>({
    url: `/api/search/products/${query}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchControllerSearchProductsQueryKey = (
  query: string,
  params?: SearchControllerSearchProductsParams,
) => {
  return [
    `/api/search/products/${query}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchControllerSearchProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchControllerSearchProducts>>,
  TError = unknown,
>(
  query: string,
  params?: SearchControllerSearchProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerSearchProducts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchControllerSearchProductsQueryKey(query, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchControllerSearchProducts>>
  > = ({ signal }) => searchControllerSearchProducts(query, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!query,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchControllerSearchProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchControllerSearchProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchControllerSearchProducts>>
>;
export type SearchControllerSearchProductsQueryError = unknown;

export const useSearchControllerSearchProducts = <
  TData = Awaited<ReturnType<typeof searchControllerSearchProducts>>,
  TError = unknown,
>(
  query: string,
  params?: SearchControllerSearchProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerSearchProducts>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchControllerSearchProductsQueryOptions(
    query,
    params,
    options,
  );

  const _query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  _query.queryKey = queryOptions.queryKey;

  return _query;
};

export const searchControllerSearchUsers = (
  query: string,
  params?: SearchControllerSearchUsersParams,
  signal?: AbortSignal,
) => {
  return customInstance<UserSearchResultDto[]>({
    url: `/api/search/users/${query}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchControllerSearchUsersQueryKey = (
  query: string,
  params?: SearchControllerSearchUsersParams,
) => {
  return [`/api/search/users/${query}`, ...(params ? [params] : [])] as const;
};

export const getSearchControllerSearchUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof searchControllerSearchUsers>>,
  TError = unknown,
>(
  query: string,
  params?: SearchControllerSearchUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerSearchUsers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchControllerSearchUsersQueryKey(query, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchControllerSearchUsers>>
  > = ({ signal }) => searchControllerSearchUsers(query, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!query,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchControllerSearchUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchControllerSearchUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchControllerSearchUsers>>
>;
export type SearchControllerSearchUsersQueryError = unknown;

export const useSearchControllerSearchUsers = <
  TData = Awaited<ReturnType<typeof searchControllerSearchUsers>>,
  TError = unknown,
>(
  query: string,
  params?: SearchControllerSearchUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerSearchUsers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchControllerSearchUsersQueryOptions(
    query,
    params,
    options,
  );

  const _query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  _query.queryKey = queryOptions.queryKey;

  return _query;
};

export const searchControllerSearchChecklists = (
  query: string,
  params?: SearchControllerSearchChecklistsParams,
  signal?: AbortSignal,
) => {
  return customInstance<ChecklistSearchResultDto[]>({
    url: `/api/search/checklists/${query}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchControllerSearchChecklistsQueryKey = (
  query: string,
  params?: SearchControllerSearchChecklistsParams,
) => {
  return [
    `/api/search/checklists/${query}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchControllerSearchChecklistsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchControllerSearchChecklists>>,
  TError = unknown,
>(
  query: string,
  params?: SearchControllerSearchChecklistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerSearchChecklists>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchControllerSearchChecklistsQueryKey(query, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchControllerSearchChecklists>>
  > = ({ signal }) => searchControllerSearchChecklists(query, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!query,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchControllerSearchChecklists>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchControllerSearchChecklistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchControllerSearchChecklists>>
>;
export type SearchControllerSearchChecklistsQueryError = unknown;

export const useSearchControllerSearchChecklists = <
  TData = Awaited<ReturnType<typeof searchControllerSearchChecklists>>,
  TError = unknown,
>(
  query: string,
  params?: SearchControllerSearchChecklistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerSearchChecklists>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchControllerSearchChecklistsQueryOptions(
    query,
    params,
    options,
  );

  const _query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  _query.queryKey = queryOptions.queryKey;

  return _query;
};

export const searchControllerSearchAll = (
  query: string,
  params?: SearchControllerSearchAllParams,
  signal?: AbortSignal,
) => {
  return customInstance<GlobalSearchResultDto[]>({
    url: `/api/search/${query}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchControllerSearchAllQueryKey = (
  query: string,
  params?: SearchControllerSearchAllParams,
) => {
  return [`/api/search/${query}`, ...(params ? [params] : [])] as const;
};

export const getSearchControllerSearchAllQueryOptions = <
  TData = Awaited<ReturnType<typeof searchControllerSearchAll>>,
  TError = unknown,
>(
  query: string,
  params?: SearchControllerSearchAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerSearchAll>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchControllerSearchAllQueryKey(query, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchControllerSearchAll>>
  > = ({ signal }) => searchControllerSearchAll(query, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!query,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof searchControllerSearchAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchControllerSearchAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchControllerSearchAll>>
>;
export type SearchControllerSearchAllQueryError = unknown;

export const useSearchControllerSearchAll = <
  TData = Awaited<ReturnType<typeof searchControllerSearchAll>>,
  TError = unknown,
>(
  query: string,
  params?: SearchControllerSearchAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchControllerSearchAll>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchControllerSearchAllQueryOptions(
    query,
    params,
    options,
  );

  const _query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  _query.queryKey = queryOptions.queryKey;

  return _query;
};

export const productControllerGetProduct = (
  id: string,
  kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX',
  signal?: AbortSignal,
) => {
  return customInstance<ProductDetailsDto>({
    url: `/api/product/${id}/${kind}`,
    method: 'GET',
    signal,
  });
};

export const getProductControllerGetProductQueryKey = (
  id: string,
  kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX',
) => {
  return [`/api/product/${id}/${kind}`] as const;
};

export const getProductControllerGetProductQueryOptions = <
  TData = Awaited<ReturnType<typeof productControllerGetProduct>>,
  TError = unknown,
>(
  id: string,
  kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productControllerGetProduct>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getProductControllerGetProductQueryKey(id, kind);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productControllerGetProduct>>
  > = ({ signal }) => productControllerGetProduct(id, kind, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(id && kind),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof productControllerGetProduct>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProductControllerGetProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof productControllerGetProduct>>
>;
export type ProductControllerGetProductQueryError = unknown;

export const useProductControllerGetProduct = <
  TData = Awaited<ReturnType<typeof productControllerGetProduct>>,
  TError = unknown,
>(
  id: string,
  kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productControllerGetProduct>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getProductControllerGetProductQueryOptions(
    id,
    kind,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const productControllerAddMember = (
  id: string,
  kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX',
  addMemberDto: AddMemberDto,
) => {
  return customInstance<void>({
    url: `/api/product/${id}/${kind}/member`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addMemberDto,
  });
};

export const getProductControllerAddMemberMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerAddMember>>,
    TError,
    { id: string; kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX'; data: AddMemberDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof productControllerAddMember>>,
  TError,
  { id: string; kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX'; data: AddMemberDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof productControllerAddMember>>,
    { id: string; kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX'; data: AddMemberDto }
  > = (props) => {
    const { id, kind, data } = props ?? {};

    return productControllerAddMember(id, kind, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProductControllerAddMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof productControllerAddMember>>
>;
export type ProductControllerAddMemberMutationBody = AddMemberDto;
export type ProductControllerAddMemberMutationError = unknown;

export const useProductControllerAddMember = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerAddMember>>,
    TError,
    { id: string; kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX'; data: AddMemberDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof productControllerAddMember>>,
  TError,
  { id: string; kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX'; data: AddMemberDto },
  TContext
> => {
  const mutationOptions = getProductControllerAddMemberMutationOptions(options);

  return useMutation(mutationOptions);
};

export const productControllerUpdateMember = (
  id: string,
  kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX',
  updateMemberRoleDto: UpdateMemberRoleDto,
) => {
  return customInstance<void>({
    url: `/api/product/${id}/${kind}/member`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateMemberRoleDto,
  });
};

export const getProductControllerUpdateMemberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerUpdateMember>>,
    TError,
    {
      id: string;
      kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX';
      data: UpdateMemberRoleDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof productControllerUpdateMember>>,
  TError,
  {
    id: string;
    kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX';
    data: UpdateMemberRoleDto;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof productControllerUpdateMember>>,
    {
      id: string;
      kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX';
      data: UpdateMemberRoleDto;
    }
  > = (props) => {
    const { id, kind, data } = props ?? {};

    return productControllerUpdateMember(id, kind, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProductControllerUpdateMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof productControllerUpdateMember>>
>;
export type ProductControllerUpdateMemberMutationBody = UpdateMemberRoleDto;
export type ProductControllerUpdateMemberMutationError = void;

export const useProductControllerUpdateMember = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerUpdateMember>>,
    TError,
    {
      id: string;
      kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX';
      data: UpdateMemberRoleDto;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof productControllerUpdateMember>>,
  TError,
  {
    id: string;
    kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX';
    data: UpdateMemberRoleDto;
  },
  TContext
> => {
  const mutationOptions =
    getProductControllerUpdateMemberMutationOptions(options);

  return useMutation(mutationOptions);
};

export const productControllerDeleteMember = (
  id: string,
  kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX',
  removeMemberDto: RemoveMemberDto,
) => {
  return customInstance<void>({
    url: `/api/product/${id}/${kind}/member`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: removeMemberDto,
  });
};

export const getProductControllerDeleteMemberMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerDeleteMember>>,
    TError,
    {
      id: string;
      kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX';
      data: RemoveMemberDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof productControllerDeleteMember>>,
  TError,
  { id: string; kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX'; data: RemoveMemberDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof productControllerDeleteMember>>,
    {
      id: string;
      kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX';
      data: RemoveMemberDto;
    }
  > = (props) => {
    const { id, kind, data } = props ?? {};

    return productControllerDeleteMember(id, kind, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProductControllerDeleteMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof productControllerDeleteMember>>
>;
export type ProductControllerDeleteMemberMutationBody = RemoveMemberDto;
export type ProductControllerDeleteMemberMutationError = unknown;

export const useProductControllerDeleteMember = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productControllerDeleteMember>>,
    TError,
    {
      id: string;
      kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX';
      data: RemoveMemberDto;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof productControllerDeleteMember>>,
  TError,
  { id: string; kind: 'DRIVE' | 'CALENDAR' | 'MAILBOX'; data: RemoveMemberDto },
  TContext
> => {
  const mutationOptions =
    getProductControllerDeleteMemberMutationOptions(options);

  return useMutation(mutationOptions);
};

export const tenantControllerCreate = () => {
  return customInstance<void>({ url: `/api/tenants/create`, method: 'POST' });
};

export const getTenantControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantControllerCreate>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantControllerCreate>>,
    void
  > = () => {
    return tenantControllerCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerCreate>>
>;

export type TenantControllerCreateMutationError = void;

export const useTenantControllerCreate = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tenantControllerCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getTenantControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

export const tenantControllerGetOrgUnits = (signal?: AbortSignal) => {
  return customInstance<OrgUnitsDto>({
    url: `/api/tenants/orgunit`,
    method: 'GET',
    signal,
  });
};

export const getTenantControllerGetOrgUnitsQueryKey = () => {
  return [`/api/tenants/orgunit`] as const;
};

export const getTenantControllerGetOrgUnitsQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantControllerGetOrgUnits>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantControllerGetOrgUnits>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTenantControllerGetOrgUnitsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tenantControllerGetOrgUnits>>
  > = ({ signal }) => tenantControllerGetOrgUnits(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantControllerGetOrgUnits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TenantControllerGetOrgUnitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerGetOrgUnits>>
>;
export type TenantControllerGetOrgUnitsQueryError = unknown;

export const useTenantControllerGetOrgUnits = <
  TData = Awaited<ReturnType<typeof tenantControllerGetOrgUnits>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantControllerGetOrgUnits>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTenantControllerGetOrgUnitsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const tenantControllerSetOrgUnits = (orgUnitsDto: OrgUnitsDto) => {
  return customInstance<void>({
    url: `/api/tenants/orgunit`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: orgUnitsDto,
  });
};

export const getTenantControllerSetOrgUnitsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerSetOrgUnits>>,
    TError,
    { data: OrgUnitsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantControllerSetOrgUnits>>,
  TError,
  { data: OrgUnitsDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantControllerSetOrgUnits>>,
    { data: OrgUnitsDto }
  > = (props) => {
    const { data } = props ?? {};

    return tenantControllerSetOrgUnits(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantControllerSetOrgUnitsMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerSetOrgUnits>>
>;
export type TenantControllerSetOrgUnitsMutationBody = OrgUnitsDto;
export type TenantControllerSetOrgUnitsMutationError = unknown;

export const useTenantControllerSetOrgUnits = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerSetOrgUnits>>,
    TError,
    { data: OrgUnitsDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tenantControllerSetOrgUnits>>,
  TError,
  { data: OrgUnitsDto },
  TContext
> => {
  const mutationOptions =
    getTenantControllerSetOrgUnitsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const tenantControllerGetImpersonator = (signal?: AbortSignal) => {
  return customInstance<ImpersonatorDto>({
    url: `/api/tenants/impersonator`,
    method: 'GET',
    signal,
  });
};

export const getTenantControllerGetImpersonatorQueryKey = () => {
  return [`/api/tenants/impersonator`] as const;
};

export const getTenantControllerGetImpersonatorQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantControllerGetImpersonator>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantControllerGetImpersonator>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTenantControllerGetImpersonatorQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tenantControllerGetImpersonator>>
  > = ({ signal }) => tenantControllerGetImpersonator(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantControllerGetImpersonator>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TenantControllerGetImpersonatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerGetImpersonator>>
>;
export type TenantControllerGetImpersonatorQueryError = unknown;

export const useTenantControllerGetImpersonator = <
  TData = Awaited<ReturnType<typeof tenantControllerGetImpersonator>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantControllerGetImpersonator>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTenantControllerGetImpersonatorQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const tenantControllerSetImpersonator = (
  impersonatorDto: ImpersonatorDto,
) => {
  return customInstance<void>({
    url: `/api/tenants/impersonator`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: impersonatorDto,
  });
};

export const getTenantControllerSetImpersonatorMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerSetImpersonator>>,
    TError,
    { data: ImpersonatorDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantControllerSetImpersonator>>,
  TError,
  { data: ImpersonatorDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantControllerSetImpersonator>>,
    { data: ImpersonatorDto }
  > = (props) => {
    const { data } = props ?? {};

    return tenantControllerSetImpersonator(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantControllerSetImpersonatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerSetImpersonator>>
>;
export type TenantControllerSetImpersonatorMutationBody = ImpersonatorDto;
export type TenantControllerSetImpersonatorMutationError = unknown;

export const useTenantControllerSetImpersonator = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerSetImpersonator>>,
    TError,
    { data: ImpersonatorDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tenantControllerSetImpersonator>>,
  TError,
  { data: ImpersonatorDto },
  TContext
> => {
  const mutationOptions =
    getTenantControllerSetImpersonatorMutationOptions(options);

  return useMutation(mutationOptions);
};

export const tenantControllerGetAuthorizedUsers = (signal?: AbortSignal) => {
  return customInstance<GetAuthorizedUsersDto>({
    url: `/api/tenants/authorized`,
    method: 'GET',
    signal,
  });
};

export const getTenantControllerGetAuthorizedUsersQueryKey = () => {
  return [`/api/tenants/authorized`] as const;
};

export const getTenantControllerGetAuthorizedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantControllerGetAuthorizedUsers>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantControllerGetAuthorizedUsers>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTenantControllerGetAuthorizedUsersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tenantControllerGetAuthorizedUsers>>
  > = ({ signal }) => tenantControllerGetAuthorizedUsers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantControllerGetAuthorizedUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TenantControllerGetAuthorizedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerGetAuthorizedUsers>>
>;
export type TenantControllerGetAuthorizedUsersQueryError = unknown;

export const useTenantControllerGetAuthorizedUsers = <
  TData = Awaited<ReturnType<typeof tenantControllerGetAuthorizedUsers>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantControllerGetAuthorizedUsers>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getTenantControllerGetAuthorizedUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const tenantControllerAddAuthorizedUser = (
  addAuthorizedUserDto: AddAuthorizedUserDto,
) => {
  return customInstance<void>({
    url: `/api/tenants/authorized`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: addAuthorizedUserDto,
  });
};

export const getTenantControllerAddAuthorizedUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerAddAuthorizedUser>>,
    TError,
    { data: AddAuthorizedUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantControllerAddAuthorizedUser>>,
  TError,
  { data: AddAuthorizedUserDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantControllerAddAuthorizedUser>>,
    { data: AddAuthorizedUserDto }
  > = (props) => {
    const { data } = props ?? {};

    return tenantControllerAddAuthorizedUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantControllerAddAuthorizedUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerAddAuthorizedUser>>
>;
export type TenantControllerAddAuthorizedUserMutationBody =
  AddAuthorizedUserDto;
export type TenantControllerAddAuthorizedUserMutationError = unknown;

export const useTenantControllerAddAuthorizedUser = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerAddAuthorizedUser>>,
    TError,
    { data: AddAuthorizedUserDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tenantControllerAddAuthorizedUser>>,
  TError,
  { data: AddAuthorizedUserDto },
  TContext
> => {
  const mutationOptions =
    getTenantControllerAddAuthorizedUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const tenantControllerRemoveAuthorizedUser = (
  removeAuthorizedUserDto: RemoveAuthorizedUserDto,
) => {
  return customInstance<void>({
    url: `/api/tenants/authorized`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: removeAuthorizedUserDto,
  });
};

export const getTenantControllerRemoveAuthorizedUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerRemoveAuthorizedUser>>,
    TError,
    { data: RemoveAuthorizedUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantControllerRemoveAuthorizedUser>>,
  TError,
  { data: RemoveAuthorizedUserDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantControllerRemoveAuthorizedUser>>,
    { data: RemoveAuthorizedUserDto }
  > = (props) => {
    const { data } = props ?? {};

    return tenantControllerRemoveAuthorizedUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantControllerRemoveAuthorizedUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerRemoveAuthorizedUser>>
>;
export type TenantControllerRemoveAuthorizedUserMutationBody =
  RemoveAuthorizedUserDto;
export type TenantControllerRemoveAuthorizedUserMutationError = unknown;

export const useTenantControllerRemoveAuthorizedUser = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerRemoveAuthorizedUser>>,
    TError,
    { data: RemoveAuthorizedUserDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tenantControllerRemoveAuthorizedUser>>,
  TError,
  { data: RemoveAuthorizedUserDto },
  TContext
> => {
  const mutationOptions =
    getTenantControllerRemoveAuthorizedUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const tenantControllerGetBillingInfo = (signal?: AbortSignal) => {
  return customInstance<GetBillingInfoDto>({
    url: `/api/tenants/billing-info`,
    method: 'GET',
    signal,
  });
};

export const getTenantControllerGetBillingInfoQueryKey = () => {
  return [`/api/tenants/billing-info`] as const;
};

export const getTenantControllerGetBillingInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof tenantControllerGetBillingInfo>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantControllerGetBillingInfo>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTenantControllerGetBillingInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tenantControllerGetBillingInfo>>
  > = ({ signal }) => tenantControllerGetBillingInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tenantControllerGetBillingInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TenantControllerGetBillingInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerGetBillingInfo>>
>;
export type TenantControllerGetBillingInfoQueryError = void;

export const useTenantControllerGetBillingInfo = <
  TData = Awaited<ReturnType<typeof tenantControllerGetBillingInfo>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tenantControllerGetBillingInfo>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getTenantControllerGetBillingInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const tenantControllerSetBillingInfo = (
  setBillingInfoDto: SetBillingInfoDto,
) => {
  return customInstance<void>({
    url: `/api/tenants/billing-info`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setBillingInfoDto,
  });
};

export const getTenantControllerSetBillingInfoMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerSetBillingInfo>>,
    TError,
    { data: SetBillingInfoDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tenantControllerSetBillingInfo>>,
  TError,
  { data: SetBillingInfoDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tenantControllerSetBillingInfo>>,
    { data: SetBillingInfoDto }
  > = (props) => {
    const { data } = props ?? {};

    return tenantControllerSetBillingInfo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TenantControllerSetBillingInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof tenantControllerSetBillingInfo>>
>;
export type TenantControllerSetBillingInfoMutationBody = SetBillingInfoDto;
export type TenantControllerSetBillingInfoMutationError = void;

export const useTenantControllerSetBillingInfo = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tenantControllerSetBillingInfo>>,
    TError,
    { data: SetBillingInfoDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tenantControllerSetBillingInfo>>,
  TError,
  { data: SetBillingInfoDto },
  TContext
> => {
  const mutationOptions =
    getTenantControllerSetBillingInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const authControllerLogin = (params: AuthControllerLoginParams) => {
  return customInstance<LoginInfoDto>({
    url: `/api/auth/login`,
    method: 'POST',
    params,
  });
};

export const getAuthControllerLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogin>>,
    TError,
    { params: AuthControllerLoginParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerLogin>>,
  TError,
  { params: AuthControllerLoginParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerLogin>>,
    { params: AuthControllerLoginParams }
  > = (props) => {
    const { params } = props ?? {};

    return authControllerLogin(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogin>>
>;

export type AuthControllerLoginMutationError = unknown;

export const useAuthControllerLogin = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogin>>,
    TError,
    { params: AuthControllerLoginParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof authControllerLogin>>,
  TError,
  { params: AuthControllerLoginParams },
  TContext
> => {
  const mutationOptions = getAuthControllerLoginMutationOptions(options);

  return useMutation(mutationOptions);
};

export const authControllerLogout = () => {
  return customInstance<void>({ url: `/api/auth/logout`, method: 'DELETE' });
};

export const getAuthControllerLogoutMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogout>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerLogout>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerLogout>>,
    void
  > = () => {
    return authControllerLogout();
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogout>>
>;

export type AuthControllerLogoutMutationError = unknown;

export const useAuthControllerLogout = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogout>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof authControllerLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAuthControllerLogoutMutationOptions(options);

  return useMutation(mutationOptions);
};

export const authControllerGetMe = (signal?: AbortSignal) => {
  return customInstance<LoginInfoDto>({
    url: `/api/auth/me`,
    method: 'GET',
    signal,
  });
};

export const getAuthControllerGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getAuthControllerGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerGetMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof authControllerGetMe>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerGetMeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authControllerGetMe>>
  > = ({ signal }) => authControllerGetMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerGetMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AuthControllerGetMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetMe>>
>;
export type AuthControllerGetMeQueryError = unknown;

export const useAuthControllerGetMe = <
  TData = Awaited<ReturnType<typeof authControllerGetMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof authControllerGetMe>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getAuthControllerGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const syncControllerGetSyncInfo = (signal?: AbortSignal) => {
  return customInstance<SyncInfoDto>({
    url: `/api/sync/info`,
    method: 'GET',
    signal,
  });
};

export const getSyncControllerGetSyncInfoQueryKey = () => {
  return [`/api/sync/info`] as const;
};

export const getSyncControllerGetSyncInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof syncControllerGetSyncInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof syncControllerGetSyncInfo>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSyncControllerGetSyncInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof syncControllerGetSyncInfo>>
  > = ({ signal }) => syncControllerGetSyncInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof syncControllerGetSyncInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SyncControllerGetSyncInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof syncControllerGetSyncInfo>>
>;
export type SyncControllerGetSyncInfoQueryError = unknown;

export const useSyncControllerGetSyncInfo = <
  TData = Awaited<ReturnType<typeof syncControllerGetSyncInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof syncControllerGetSyncInfo>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSyncControllerGetSyncInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const syncControllerStartSync = () => {
  return customInstance<void>({ url: `/api/sync/start`, method: 'POST' });
};

export const getSyncControllerStartSyncMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncControllerStartSync>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncControllerStartSync>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncControllerStartSync>>,
    void
  > = () => {
    return syncControllerStartSync();
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncControllerStartSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncControllerStartSync>>
>;

export type SyncControllerStartSyncMutationError = void;

export const useSyncControllerStartSync = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncControllerStartSync>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncControllerStartSync>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getSyncControllerStartSyncMutationOptions(options);

  return useMutation(mutationOptions);
};
